export default "__VITE_ASSET__CXi$P9eM__"